import Axios from "axios";

export const SelectFactureLig = (num, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/Api/LigFACCLIs?type=F&numfac=${num}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "F_LIG_SELECT", payload: response.data });
    });
  };
};
